import axios from "axios";
import envConfig from "../bin/env.config";

export const setTags = (tags = []) => ({
  type: "SET_TAGS",
  tags,
});

export const setTagsLoading = (isLoading = false) => ({
  type: "SET_TAGS_LOADING",
  isLoading,
});

export const clearTags = () => ({
  type: "CLEAR_TAGS",
});

export const fetchTags = (reloadData = false) => {
  return (dispatch, getState) => {
    let isReady = getState().tags.isReady;
    if(!reloadData && isReady) return;
   
    dispatch(setTagsLoading(true));
    const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/matching/group/tag/list`;
    axios.post(url, {
    },
    {
      headers: {
        'Authorization': JSON.stringify(getState().session.token)
      }
    }).then((result) => {
      dispatch(setTags(result.data.data));
    }).catch((error) => {
      console.log('error', error);
      dispatch(setTagsLoading(false));
    });
  };
};


